import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0155',
    ecrans: ['00-2']
});
